import { isSuperAdminUser } from "./brandAuth";
import { userIsExpertCoach } from "./homeRole";

export function clubIdOfUser(user) {
  return user?.club_id || user?.club_details?.club_id || user?.club?.club_id || null;
}

function isClubAdmin(user) {
  if (Number(user?.type_user_id) === 2 || user?.hasModeratorRole === true) return true;
  const names = Array.isArray(user?.all_role_names) ? user.all_role_names : [];
  const roles = Array.isArray(user?.all_roles) ? user.all_roles.map(String) : [];
  return names.includes("Admin") || names.includes("Moderator") || roles.includes("r2") || roles.includes("r9");
}

/** Matches backend allowLevelClassificationEditorForClub: club Admin / Moderator or Expert Coach. */
export function canEditClubLevelMatrix(user) {
  if (!user || !clubIdOfUser(user)) return false;
  return isSuperAdminUser(user) || isClubAdmin(user) || userIsExpertCoach(user);
}

export function canEditDefaultLevelMatrix(user) {
  return isSuperAdminUser(user);
}

export function canAccessLevelMatrix(user) {
  if (!user) return false;
  return canEditDefaultLevelMatrix(user) || canEditClubLevelMatrix(user);
}
